import { combineReducers } from "redux";
import column_master from "./column_master_reducer";
import { auth_reducer, sso_reducer } from "./auth_reducer";
import app from "./app_reducer";
import sidenav from "./sidenav_reducer";

const rootReducer = combineReducers({
  column_master,
  auth_reducer,
  sso_reducer,
  app,
  sidenav,
});

export default rootReducer;
